<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style>
	.el-input-group__append,
	.el-input-group__prepend {
		background: #E1251B !important;
		color: #fff !important;
		border: 1px solid #E1251B !important;
	}

	.el-input-group--append .el-input__inner,
	.el-input-group__prepend {
		border: 1px solid #E1251B !important;
	}

	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #E1251B !important;
	}

	.el-pagination.is-background .btn-next,
	.el-pagination.is-background .btn-prev,
	.el-pagination.is-background .el-pager li {
		background-color: #fff !important;
	}

	.el-pager li:hover {
		color: #E1251B !important;
	}

	.el-radio__input.is-checked .el-radio__inner {
		border-color: #E1251B !important;
		background: #E1251B !important;
	}

	.el-radio__input.is-checked+.el-radio__label {
		color: #E1251B !important;
	}

	* {
		padding: 0;
		margin: 0;

	}

	body {
		background: #F6F5F7;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue